import { METHODS, request } from '../axiosInstances';

export default {
  get: (params = {}) => request(METHODS.GET, `/assets/`, { params }),
  getCount: (params = {}) => request(METHODS.GET, `/assets/count/`, { params }),
  getProgress: (id: number, params = {}) => request(METHODS.GET, `/jobs/${id}/`, { params }),
};
